/**
 * Where the Spotlight launcher grows from when it expands: out of the side it
 * is positioned on, otherwise out of the bottom center.
 */
export const getSpotlightTransformOrigin = position => {
  if (position === 'right') return 'bottom right';
  if (position === 'left') return 'bottom left';
  return 'bottom center';
};